import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=c3114dd0&scoped=true"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"
import style0 from "./structure.vue?vue&type=style&index=0&id=c3114dd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3114dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3114dd0')) {
      api.createRecord('c3114dd0', component.options)
    } else {
      api.reload('c3114dd0', component.options)
    }
    module.hot.accept("./structure.vue?vue&type=template&id=c3114dd0&scoped=true", function () {
      api.rerender('c3114dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/training/structure.vue"
export default component.exports